//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../Assemblies/Assemblies.SelectComponent.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AddComponentsExclusively",1,0],[0,"ChangeoverName",1,0],[0,"ClonedProductName",1,0],[0,"NewChangeoverName",1,0],[0,"RenameComponent",1,0],[1,"SelectComponents",0,"Assemblies.SelectComponentList",0],[1,"SelectProduct",0,"Assemblies.SelectComponent",0],[0,"SelectedArrangementName",1,0],[0,"Type",1,0]],[[[],"UseArrangement",{},0,0],[[],"RenameArrangement",{},0,0],[["removeComponents"],"DeleteArrangement",{},1,0],[[],"AddToChangeover",{},0,0],[[],"RemoveFromChangeover",{},0,0]],[]];
SPLM.Tooling.ChangeoverManagementBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ChangeoverManagementBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ChangeoverManagementBuilder.Types = Object.freeze({
    "Create" : "Create", "Manage" : "Manage"});

export default SPLM;